// @core/api/endpoints/billing/get_billing_policy_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BillingPolicyResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get entity billing policy
 * Returns the billing policy directly attached to the specified entity (if any). Does NOT resolve inheritance — use ResolveBillingContext for that.
 */
export async function GetBillingPolicyByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<BillingPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing/:entity_type/:entity_id/policy`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<BillingPolicyResponse>(requestPath, { ...requestOptions });
}
